/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Category of a persisted action event log entry. Derived from the routing-key verb by the auditing consumer.
 */
export enum EnumActionEventCategory {
    /**
     * Routine event. Default for unmapped verbs.
     */
    Info = 0,
    /**
     * Successful outcome.
     */
    Success = 1,
    /**
     * Something the user should be aware of.
     */
    Warning = 2,
    /**
     * Failed outcome.
     */
    Error = 3,
    /**
     * Worth the user's attention but not a warning.
     */
    Notice = 4,
}
